import * as React from 'react';
import { Button, Icon } from '@alifd/next';
// @ts-ignore: Unreachable code error
import Alitalk from '@alife/icbu-alitalk-react';

export default function CallUsBtn(props: any) {
  const {
    i18n,
    productOwnMemberAlitalkEncryptId,
    productId,
    bucket,
    className,
    onClick,
  } = props;

  // 场景来源参数
  const scene = {
    fromPage: 'product_detail',
    bizType: 'call_us',
    bucket: bucket || '',
  };

  return (
    // react版alitalk组件
    <Alitalk
      uid={productOwnMemberAlitalkEncryptId}
      pid={productId}
      bizType="1"
      bizId={productId}
      sceneType="detail"
      action="callMeeting"
      scene={scene} // 场景来源参数
    >
      <div
        className={`action-button-std action-video J-action-video ${className}`}
        onClick={onClick}
        title={i18n['rightAction.video'] || 'Call Us'}
        //@ts-ignore
        spm="pdpvideobtn"
      >
        <Button type="secondary"><Icon type="phone" />{i18n['rightAction.video']}</Button>
      </div>
    </Alitalk>
  );
}
